import { NgModule } from "@angular/core";
import { TranslateModule } from "@ngx-translate/core";
import { ParticipantKeyValidatorDirective } from "../core/directives/validadeParticipantKey";

@NgModule({
  declarations: [
    ParticipantKeyValidatorDirective,
  ],
    imports: [
      // outras importações...
      TranslateModule
    ],
    exports: [
      // outras exportações...
      ParticipantKeyValidatorDirective,
      TranslateModule
    ]
  })
  export class SharedModule { }